<template>
  <div class="growth">
    <div class="growth-top">
      <el-button type="primary" class="add">添加新成长记录</el-button>
      <el-select v-model="query.growthType" clearable placeholder="成长类型" class="growth-type">
        <el-option
          v-for="item in growthType"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="divider"></div>
      <el-select v-model="inputValue" @change="employeTime" placeholder="请选择" class="handle-select">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div v-if="inputValue !== 'all'" class="date-box">
        <el-date-picker
          v-model="query.time"
          type="daterange"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="getGrowthList"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
    </div>
    <div class="material-record">
      <!-- 档案列表 -->
      <div class="material-group" v-if="material.length">
        <div class="timeline">
          <div class="item" v-for="(item,index) in 2" :key="index">
            <div class="title">
              <div>
                <span>员工</span>
                <span class="name">李少杰</span>
                <span>根据以往的工作表现，经公司领导研究决定，同意晋升为副总经理职位</span>
              </div>
              <div>
                <span class="title-action" @click="edit">管理</span>
                <span class="title-action">删除</span>
              </div>
              <!-- 日期时间 -->
              <div class="date">
                <div class="year">2019</div>
                <div class="mounth">03月26日</div>
              </div>
            </div>
            <div class="content">
              <!-- 图片 -->
              <div class="flex">
                <div class="img-group" v-for="(item,index) in 3" :key="index">
                  <el-image
                    class="img"
                    src="https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1409395700,54306102&fm=26&gp=0.jpg"
                    fit="cover"
                    :preview-src-list="['https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1409395700,54306102&fm=26&gp=0.jpg']"
                  ></el-image>
                  <div class="info">
                    <div class="flex-between">
                      <div>李坤杰</div>
                      <div>2018.12.31</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 视频 -->
              <div class="flex">
                <div
                  class="video-group"
                  v-for="(item,index) in videoList"
                  :key="index"
                  @click="videoUrl=item"
                >
                  <video class="video" :src="item"></video>
                  <div class="play">
                    <svg-icon icon-class="arrow-down" class="arrow" />
                  </div>
                </div>
              </div>
              <!-- 文件 -->
              <div class="files-group">
                <div class="file" v-for="(item,index) in 2" :key="index">
                  <span class="file-title">【资料文件】 关于任命李少杰为副总经理职位的通知.docx</span>
                  <span class="file-size">163.00kb</span>
                  <span class="file-action">预览</span>
                  <span class="file-action">下载</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 查看更多 -->
          <div class="load-more-group">
            <div class="load-more">查看更多</div>
          </div>
        </div>
      </div>
      <!-- 无档案 -->
      <div class="material-empty" v-else>
        <div class="empty-box">
          <img
            src="../../../../../assets/image/material-empty.gif"
            alt="empty-img"
            class="empty-img"
          />
          <div class="empty-main">
            <p>当前组织架构暂无档案资料，点击下方“立即添加”按钮 新建档案资料。</p>
            <el-button type="primary" @click="addMaterial">立即添加</el-button>
          </div>
        </div>
      </div>
      <!-- 悬浮按钮 -->
      <el-popover
        placement="left"
        width="190"
        height="44"
        trigger="hover"
        content="拖拽调整位置，点击新增档案记录"
      >
        <div
          slot="reference"
          class="add-file"
          ref="addFile"
          @mousedown="mouseDownHandleelse($event)"
          @mouseup="mouseUpHandleelse($event)"
        >+</div>
      </el-popover>
      <!-- 视频播放 -->
      <video-play v-if="videoUrl" :url="videoUrl" @closeVideo="closeVideo"></video-play>
      <!-- 添加新记录 -->
      <el-form
        v-if="isShowAdd"
        ref="addQuery"
        :model="addQuery"
        :rules="addRules"
        label-width="4rem"
      >
        <el-dialog title="添加新记录" :visible.sync="isShowAdd" width="600px" height="306px">
          <div class="add-record">
            <el-form-item label="档案类型" prop="type">
              <el-select v-model="addQuery.type" placeholder="请选择成长类型" clearable>
                <el-option
                  v-for="item in addQueryTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述" class="auto-height" prop="desc">
              <el-input
                type="textarea"
                v-model="addQuery.desc"
                maxlength="200"
                show-word-limit
                placeholder="请输入成长描述"
                clearable
                resize="none"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="auto-height clear-margin-top"
              label="资料文件"
              v-if="addQuery.imgList.length>0||addQuery.videoList.length>0||addQuery.textList.length>0"
            >
              <div class="add-record-content">
                <!-- 图片 -->
                <div class="flex">
                  <div class="img-group" v-for="(item,index) in addQuery.imgList" :key="index">
                    <el-image class="img" :src="item.url" fit="cover"></el-image>
                    <div class="info">
                      <div class="name">李坤杰</div>
                      <div class="flex-between">
                        <div>2018.12.31</div>
                        <div @click="delFile('imgList',index,item.uid)">
                          <svg-icon class="del-icon" icon-class="del-ico"></svg-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 视频 -->
                <div class="flex">
                  <div
                    class="video-group"
                    v-for="(item,index) in addQuery.videoList"
                    :key="index"
                    @click="videoUrl=item.url"
                  >
                    <video class="video" :src="item.url"></video>
                    <div class="play">
                      <svg-icon icon-class="arrow-down" class="arrow" />
                    </div>
                    <div class="info">
                      <div class="name">李坤杰</div>
                      <div class="flex-between">
                        <div>2018.12.31</div>
                        <div @click.stop="delFile('videoList',index,item.uid)">
                          <svg-icon class="del-icon" icon-class="del-ico"></svg-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 文件 -->
                <div class="files-group">
                  <div class="file" v-for="(item,index) in addQuery.textList" :key="index">
                    <span class="file-title">【资料文件】 {{item.name}}</span>
                    <span class="file-action" @click="delFile('textList',index,item.uid)">删除</span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShowAdd = false">取消</el-button>
            <el-upload
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="uploadChange"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :file-list="fileList"
              :show-file-list="false"
              :auto-upload="false"
              multiple
              accept=".jpg, .png, .jpeg, .mp4, .txt, .pdf, .doc, .docx, .xlsx"
            >
              <el-button slot="trigger">上传资料</el-button>
              <el-button type="primary" @click="creatSubmit('addQuery')">确定</el-button>
            </el-upload>
          </span>
        </el-dialog>
      </el-form>
    </div>
  </div>
</template>

<script>
import videoPlay from "@/components/VideoPlay/index";
export default {
  components: {
    videoPlay
  },
  data() {
    return {
      inputValue: "all",
      query: {
        growthType: "全部类型",
        time: []
      },
      options: [
        {
          value: "all",
          label: "全部时间"
        },
        {
          value: "userDefined",
          label: "自定义时间"
        }
      ],
      growthType: [
        {
          value: "全部类型",
          label: "全部类型"
        },
        {
          value: "升职",
          label: "升职"
        },
        {
          value: "降职",
          label: "降职"
        },
        {
          value: "加薪",
          label: "加薪"
        },
        {
          value: "降薪",
          label: "降薪"
        },
        {
          value: "表彰",
          label: "表彰"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      fileList: [],
      videoList: ["http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"],
      uploadLoading: "", //上传加载中对象
      material: [1],
      moveDataelse: {
        x: null,
        y: null
      },
      addFilePosition: {
        //保存移动前的位置，判断是否移动
        x: null,
        y: null
      },
      videoUrl: "", //视频播放地址
      isShowAdd: false, //控制添加弹窗
      addQuery: {
        //添加数据参数
        type: "",
        desc: "",
        imgList: [],
        videoList: [],
        textList: []
      },
      addRules: {
        type: [{ required: true, message: "请选择", trigger: "change" }],
        desc: [{ required: true, message: "请输入", trigger: "change" }]
      },
      addQueryTypeOptions: [{ value: "升职", label: "升职" }]
    };
  },
  filters: {
    //   dateFilter(v){
    //       v.sp
    //   }
  },
  methods: {
    employeTime(val) {
      if (val === "all") {
        this.time = null;
        this.getGrowthList();
      }
    },
    getGrowthList() {
      //console.log("获取成长记录");
    },
    //清空参数
    clearAddQuery() {
      this.fileList = []; //文件列表
      this.addQuery = {
        //添加数据参数
        type: "",
        desc: "",
        imgList: [],
        videoList: [],
        textList: []
      };
    },
    //管理
    edit() {
      this.isShowAdd = true;
      this.clearAddQuery();
      this.fileList = [
        {
          name: "food.jpeg",
          url:
            "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1409395700,54306102&fm=26&gp=0.jpg"
        },
        {
          name: "food2.jpeg",
          url:
            "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1409395700,54306102&fm=26&gp=0.jpg"
        }
      ];

      for (let i = 0; i < this.fileList.length; i++) {
        // 图片类型
        var FileExt = this.fileList[i].name.replace(/.+\./, "");
        if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
          this.addQuery.imgList.push(this.fileList[i]); //将bade64位图片保存至数组里供上面图片显示
        }
        // 视频类型
        if (["mp4"].indexOf(FileExt.toLowerCase()) > -1) {
          this.addQuery.videoList.push(this.fileList[i]); //将bade64位图片保存至数组里供上面图片显示
        }
        // 文件类型
        if (
          ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
          -1
        ) {
          this.addQuery.textList.push(this.fileList[i]);
        }
      }
    },
    //删除文件
    delFile(key, index, uid) {
      this.addQuery[key].splice(index, 1);
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].uid == uid) {
          this.fileList.splice(i, 1);
          //console.log(this.fileList);
          return;
        }
      }
    },
    //上传失败
    uploadError(res) {
      //console.log("上传失败", res);
      this.uploadLoading.close();
      this.$message({
        message: "上传失败，请重新上传",
        type: "error"
      });
    },
    //上传成功
    uploadSuccess(res) {
      //console.log("上传成功", res);
      this.uploadLoading.close();
      this.isShowAdd = false;
      this.$message({
        message: "上传成功",
        type: "success"
      });
    },
    //添加文件、上传成功和上传失败时都会被调用
    uploadChange(file, fileList) {
      this.fileList = fileList;
      // 图片类型
      var FileExt = file.name.replace(/.+\./, "");
      if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          this.addQuery.imgList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 视频类型
      if (["mp4"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          this.addQuery.videoList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 文件类型
      if (
        ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
        -1
      ) {
        this.addQuery.textList.push(file);
      }
    },
    //确认提交
    creatSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
          // this.uploadLoading = this.$loading({
          //   lock: true,
          //   text: '上传中',
          // });
          // this.$refs.upload.submit();
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //关闭视频弹窗
    closeVideo() {
      this.videoUrl = "";
    },
    mouseDownHandleelse(event) {
      // event.currentTarget.style.cursor = 'move';
      this.addFilePosition = {
        x: this.$refs.addFile.offsetLeft,
        y: this.$refs.addFile.offsetTop
      };
      this.moveDataelse.x = event.pageX - this.$refs.addFile.offsetLeft;
      this.moveDataelse.y = event.pageY - this.$refs.addFile.offsetTop;
      window.onmousemove = this.mouseMoveHandleelse;
    },
    mouseMoveHandleelse(event) {
      let moveLeft = event.pageX - this.moveDataelse.x + "px";
      let moveTop = event.pageY - this.moveDataelse.y + "px";
      this.$refs.addFile.style.left = moveLeft;
      this.$refs.addFile.style.top = moveTop;
    },
    mouseUpHandleelse(event) {
      window.onmousemove = null;
      // event.currentTarget.style.cursor = ' pointer';
      //没有移动
      if (
        this.addFilePosition.x == this.$refs.addFile.offsetLeft &&
        this.addFilePosition.y == this.$refs.addFile.offsetTop
      ) {
        this.clearAddQuery();
        this.isShowAdd = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/pages/hr/subpage/organization/material-record.scss";
.growth {
  .material-group {
    padding: 0 28px 78px 15px;
  }
  .growth-top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .growth-type {
      margin-left: 10px;
      width: 120px;
    }

    ::v-deep .date-box {
      .el-input__inner {
        border-left: 0;
      }

      .el-icon-circle-close,
      .el-range-separator {
        position: relative;
      }
    }
  }

  .growth-main {
    height: 440px;
    background: #fff;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

    .main-item {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>